import * as R from 'ramda';

export const areModalsEmpty = modals => R.isEmpty(modals) || R.all(R.equals(false), Object.values(modals.ids || {}));
export const isModalsNotEmpty = modals => !R.isEmpty(modals) && R.any(R.equals(true), Object.values(modals.ids || {}));
